exports.TWITTER = 'twitter'
exports.FACEBOOK = 'facebook'
exports.YOUTUBE = 'youtube'
exports.REDDIT = 'reddit'
exports.INSTAGRAM = 'instagram'
exports.INSTAFEED = 'instafeed'
exports.CUSTOM = 'custom'
exports.TWITCH = 'twitch'
exports.TIKTOK = 'tiktok'
exports.TIKTOK_NATIVE = 'tiktok-native'
exports.INSTAGRAM_NATIVE = 'instagram-native'
exports.YOUTUBE_NATIVE = 'youtube-native'
exports.SNAPCHAT_NATIVE = 'snapchat-native'
exports.SONGSTATS = 'songstats'

exports.PLATFORM_NAMES_BY_ID = {
  [exports.TWITTER]: 'Twitter',
  [exports.FACEBOOK]: 'Facebook',
  [exports.YOUTUBE]: 'YouTube',
  [exports.REDDIT]: 'Reddit',
  [exports.INSTAGRAM]: 'Instagram',
  [exports.INSTAFEED]: 'Instafeed',
  [exports.TWITCH]: 'Twitch',
  [exports.TIKTOK]: 'TikTok',
  [exports.TIKTOK_NATIVE]: 'TikTok',
  [exports.INSTAGRAM_NATIVE]: 'Instagram',
  [exports.YOUTUBE_NATIVE]: 'YouTube',
  [exports.SNAPCHAT_NATIVE]: 'Snapchat',
  [exports.CUSTOM]: 'Custom RTMP',
}

exports.PRIVACY_EVERYONE = 'everyone'
exports.PRIVACY_UNLISTED = 'unlisted'
exports.PRIVACY_PRIVATE = 'private'

exports.PRIVACY_OPTIONS = [exports.PRIVACY_EVERYONE, exports.PRIVACY_UNLISTED, exports.PRIVACY_PRIVATE]

exports.HAPPS_MULTICAST_PLATFORMS = [exports.TWITTER, exports.FACEBOOK, exports.YOUTUBE, exports.REDDIT, exports.INSTAFEED]
exports.HAPPS_PARTNER_PLATFORMS = [exports.REDDIT, exports.INSTAFEED, exports.TIKTOK]

exports.SOCIAL_MULTICAST_PLATFORMS = [exports.INSTAGRAM, exports.INSTAFEED, exports.TIKTOK, exports.YOUTUBE, exports.TWITCH, exports.TWITTER, exports.FACEBOOK, exports.CUSTOM]
exports.PLATFORMS_WITH_PRIVACY_SETTINGS = [exports.YOUTUBE, exports.FACEBOOK]
